import { jsxs as i, jsx as t } from "react/jsx-runtime";
import { useState as C, useEffect as H } from "react";
import { subscribe as w, unsubscribe as y, publish as x } from "../../utils/events.js";
import { classes as N } from "../../utils/helpers.js";
import '../../assets/ActionButton.css';const S = "_scale_9huvk_1", n = {
  "action-btn": "_action-btn_9huvk_1",
  "action-btn--small": "_action-btn--small_9huvk_31",
  "action-btn--large": "_action-btn--large_9huvk_38",
  "action-btn--primary": "_action-btn--primary_9huvk_45",
  "action-btn--action": "_action-btn--action_9huvk_54",
  "action-btn--info": "_action-btn--info_9huvk_63",
  "action-btn--danger": "_action-btn--danger_9huvk_72",
  "dots-pulse": "_dots-pulse_9huvk_97",
  scale: S
};
function A({
  label: l,
  type: c = "button",
  onClick: s = () => {
  },
  varient: r = "",
  size: e = "",
  customColors: o = {
    bgColor: "",
    bgHoverColor: "",
    color: "",
    hoverColor: "",
    borderColor: "",
    borderHoverColor: ""
  },
  disabled: d,
  classname: _ = "",
  ...p
}) {
  const [a, b] = C("idle"), v = r === "" ? "" : `action-btn--${r}`, h = e === "" ? "" : `action-btn--${e}`, g = o.bgColor !== "" ? {
    "--button-bg-color": o.bgColor,
    "--button-hover-bg-color": o.bgHoverColor === "" ? o.bgColor : o.bgHoverColor,
    "--button-color": o.color,
    "--button-hover-color": o.hoverColor === "" ? o.color : o.hoverColor,
    "--button-border-color": o.borderColor === "" ? o.bgColor : o.borderColor,
    "--button-hover-border-color": o.borderHoverColor === "" && o.borderColor === "" ? o.bgColor : o.borderHoverColor
  } : null, u = () => {
    b("idle");
  }, k = (f) => {
    s(f), b("waiting"), x("scripps:actionbtn:clicked");
  };
  return H(() => (w("scripps:action:completed", u), () => {
    y("scripps:action:completed");
  }), []), /* @__PURE__ */ i(
    "button",
    {
      type: c,
      className: N([
        n["action-btn"],
        "action-btn",
        _,
        r === "" ? "" : n[v],
        e === "" ? "" : n[h]
      ]),
      onClick: k,
      disabled: a === "waiting" || d,
      style: g,
      ...p,
      children: [
        a !== "waiting" && /* @__PURE__ */ t("span", { className: n["action-btn__label"], children: l }),
        a === "waiting" && /* @__PURE__ */ i("div", { className: n["dots-pulse"], children: [
          /* @__PURE__ */ t("span", {}),
          /* @__PURE__ */ t("span", {}),
          /* @__PURE__ */ t("span", {})
        ] })
      ]
    }
  );
}
export {
  A as ActionButton,
  A as default
};
